module.exports = __webpack_public_path__ + "media/images/flags/4x3/tjk-839f273d8f391e996568ded4f1b4814d.svg";